var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10V16.5667C11.7 16.8167 11.6167 17.0833 11.425 17.2583C11.3479 17.3356 11.2563 17.3969 11.1555 17.4387C11.0547 17.4805 10.9466 17.502 10.8375 17.502C10.7283 17.502 10.6203 17.4805 10.5195 17.4387C10.4187 17.3969 10.3271 17.3356 10.25 17.2583L8.57499 15.5833C8.4841 15.4945 8.41499 15.3858 8.37307 15.2658C8.33115 15.1458 8.31754 15.0178 8.33332 14.8917V10H8.30832L3.50832 3.85C3.37299 3.67628 3.31193 3.45605 3.33848 3.23744C3.36502 3.01884 3.47702 2.81962 3.64999 2.68333C3.80832 2.56667 3.98332 2.5 4.16665 2.5H15.8333C16.0167 2.5 16.1917 2.56667 16.35 2.68333C16.523 2.81962 16.635 3.01884 16.6615 3.23744C16.688 3.45605 16.627 3.67628 16.4917 3.85L11.6917 10H11.6667Z",
    fill: "#0D0D0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.21154c858b8af3ab0123b506783a2838.svg";
export { ForwardRef as ReactComponent };